import React, { useState } from "react";
import Filters from "./Filters";

const Widgets = () => {
    const [open, setOpen] = useState(false);

    const translations = {
        show_filters: Drupal.t("Show filters") + ':',
    }

    if (open === true) {
        return (
          <div className="widget">
                <div className="paper paper--boxShadow">
                  <div className="inner">
                    <div className="row no-margin">
                      <div className="col-12 col-md-11">
                        <Filters />
                      </div>
                        <div className="col-12 col-md-1" style={{ padding: 0 }}>
                            <button
                                className="btn btn-outline-primary restaurants-map-brands__btn"
                                onClick={() => setOpen(false)}
                            >
                                <i className="fas fa-angle-left"></i>
                            </button>
                        </div>
                    </div>
                  </div>
                </div>
          </div>
        );
    } else {
        return (
            <div className="widget">
                <div className="inner">
                    <div className="row no-margin">
                        <div className="col-2">
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={() => setOpen(true)}
                            >
                                {translations['show_filters']}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};
export default Widgets;
